import Button from "components/common/Button";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const PageError = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="container min-h-50 py-20 d-flex">
            <div className="m-auto text-center">
                <h1 className="display-1">{t("707", "Ops")}!</h1>
                <h1>
                    {t("708", "Something went wrong")}. {t("709", "Please contact administrator")}.
                </h1>
                <Button onClick={() => navigate("/")}>
                    <span className="d-flex align-items-center justify-content-center">
                        <i className="fa-solid fa-house"></i>
                        <span> Go To HomePage</span>
                    </span>
                </Button>
                <Button onClick={() => window.location.reload()} variant="outline">
                    <span className="d-flex align-items-center justify-content-center">
                        <i className="fa-solid fa-rotate-right"></i>
                        <spa> Reload</spa>
                    </span>
                </Button>
            </div>
        </div>
    );
};

export default PageError;
